/* ReportGeneratorEditorComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./ReportGeneratorEditorRenderer");

class ReportGeneratorEditorComponent extends EventEmitter {
    constructor(reportService, logger, userSession, steveUtils, io, modalUserFeedback) {
        super();
        this._reportService = reportService;
        this._logger = logger;
        this._userSession = userSession;
        this._modalUserFeedback = modalUserFeedback;
        this._io = io;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        this._userSession.on(
            "OrganizationChange",
            (this._onOrganizationChange = this._onOrganizationChange.bind(this))
        );
    }

    _unregisterListeners() {
        this._userSession.removeListener("OrganizationChange", this._onOrganizationChange);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get io() {
        return this._io;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer
            .shutdown()
            .then(() => {
                this._renderer = undefined;
                this._logger = undefined;
                this._userSession = undefined;
                this._reportService = undefined;
                this._io = undefined;
            })
            .catch((err) => {
                this._logger.warn({error: err}, "ReportGeneratorEditorComponent.shutdown() error.");
            });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onOrganizationChange() {
        // TODO - Do I need to do anything with this?
        this._renderer.render();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    runReport(name) {
        const req = {
            reportName: name,
            organizationId: this._userSession.activeOrganization.id,
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };

        const isValidJSON = (str) => {
            // First, check if the input is actually a string
            if (typeof str !== "string") {
                throw new Error("Result of report is not properly formatted.");
            }

            try {
                JSON.parse(str);
                return true;
            } catch {
                return false;
            }
        };

        return this._reportService
            .report(req)
            .then((result) => {
                let fileExtension = ".csv";

                if (isValidJSON(result)) {
                    fileExtension = ".json";
                }

                const fileName = name + "-" + new Date().toISOString() + fileExtension;
                const file = new this._io.File(fileName, null, result);
                return this._io.fileFactory.saveFile(file);
            })
            .catch((err) => {
                this._logger.warn(
                    {error: err, reportName: name},
                    "ReportGeneratorEditorComponent.runReport error."
                );
                this._modalUserFeedback.displayError({
                    errorMsg:
                        err.message ||
                        "The current packages failed to generate the selected report.",
                    errorCode: err.errorCode,
                });
                return Promise.reject(err);
            });
    }

    getReports() {
        return this._reportService.getReportTypesWithDescription();
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = ReportGeneratorEditorComponent;

ReportGeneratorEditorComponent.$inject = [
    "$teve.services.instance.Report",
    "$teve.logger",
    "$teve.userSession",
    "$teve.utils",
    "$teve.io",
    "$teve.ui.userFeedback",
];
